import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { IconStyled, Subtitle } from './DocumentStatus.styles';
import { grey, darkBlue } from 'src/styles/colors';
import { Link } from 'src/components/Text';
import { t } from 'i18next';
import { DownloadIcon } from '../../../Icons/DownloadIcon';
import { MvpArrowRight } from '../../../Icons/MvpArrowRight';

interface Props extends GridProps {
  isRead: boolean;
  canDownload?: boolean;
  showText?: boolean;
  downloadLink: string;
}

export const DocumentStatus = ({
  canDownload = false,
  isRead,
  showText = true,
  downloadLink,
}: Props) => {
  const renderText = () => {
    if (canDownload) {
      return (
        <Link href={downloadLink} onClick={e => e.stopPropagation()}>
          {t('Download')}
        </Link>
      );
    } else if (isRead) {
      return <Subtitle aria-label={t('Seen')}>{t('Seen')}</Subtitle>;
    } else {
      return (
        <Subtitle aria-label={t('Open')} style={{ color: darkBlue }}>
          {t('Open')}
        </Subtitle>
      );
    }
  };

  const isFromMvpApp = globalThis.location.pathname.includes('/app');

  const iconToShowWhenCantDownload = isFromMvpApp ? (
    <MvpArrowRight data-testid="external-link" />
  ) : (
    <FontAwesomeIcon icon={faExternalLinkAlt} data-testid="external-link" />
  );

  const canDownloadDocumentIcon = canDownload ? (
    <Link href={downloadLink} onClick={e => e.stopPropagation()}>
      {isFromMvpApp ? (
        <DownloadIcon />
      ) : (
        <IconStyled
          data-testid="download-icon"
          type="download"
          aria-label={t('Download')}
        />
      )}
    </Link>
  ) : (
    iconToShowWhenCantDownload
  );

  return (
    <Grid container direction="column" alignItems="center">
      <Grid item xs="auto">
        {isRead && !canDownload ? (
          <IconStyled
            data-testid="ok-icon"
            type="ok"
            aria-label={t('Read')}
            color={grey}
          />
        ) : (
          canDownloadDocumentIcon
        )}
      </Grid>
      {showText && <Grid item>{renderText()}</Grid>}
    </Grid>
  );
};
